// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2ha55","label":"CategoryService_label__cDVd-","location":"CategoryService_location__388d_"};